import React from 'react';
import glamorous from 'glamorous';

import ImgWithSource from '../img-with-source';
import productCode1Img from '../../../../assets/images/docs/product-codes/prod-code-1.png';

const Definition = () => {
  return (
    <div>
      <h4>
        Definition
      </h4>
      <p>
        <a href="http://www.gs1.org/gpc" target="_blank">Global Product Classification
          (GPC)</a> codes <strong>MUST</strong> be used for
        the product identification in the <i>GlobalRecalls</i> portal. The GS1 GPC is a system that gives buyers and
        sellers a common language for grouping products in the
        same way, everywhere in the world.
      </p>
      <p>
        The GPC is a rules-based, four-tier classification system for grouping products:
      </p>
      <glamorous.Ul
        className="pt-list"
        css={{
          listStyle: 'decimal',
        }}
      >
        <li>Segment</li>
        <li>Family</li>
        <li>Class</li>
        <li>
          Brick: identifies a category of similar products and can be further characterised by brick attributes and
          attribute values.
        </li>
      </glamorous.Ul>
      <ImgWithSource
        src={productCode1Img}
        source="http://www.gs1.org/gpc"
      />
    </div>
  );
};

export default Definition;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/product-codes/definition.js